/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-10-23 18:22:28
 * @Description:
 */
import { createRouter, createWebHashHistory } from 'vue-router' //createWebHistory

import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue';
import agent from './agent';
import org from './org';
import group from './group';
import user from './user';
import cardSales from './cardSales';
import notice from './notice';
import scan from './scan';
import payment from './payment';
import sos from './sos';
import fence from './fence';
import recording from './recording';
import registerAccount from './registerAccount';
import patrol from './patrol';

const routes = [
  { //登录页面
    path: '/',
    name: 'LoginView',
    component: Login
  },
  { //首页
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  ...agent,
  ...org,
  ...group,
  ...user,
  ...cardSales,
  ...notice,
  ...scan,
  ...payment,
  ...sos,
  ...fence,
  ...recording,
  ...registerAccount,
  ...patrol,
  {
    path: "/resetPwd",    //重置密码
    name: 'resetPwd',
    component: () => import("@/views/agent/resetPwd.vue")
  },
  {
    path: "/Search",    //搜索
    name: 'Search',
    component: () => import("@/views/Search.vue"),
    meta: {
      // keepAlive: true // 需要缓存
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
